import { render, staticRenderFns } from "./Geophysical.vue?vue&type=template&id=7210f73c&scoped=true"
import script from "./Geophysical.vue?vue&type=script&lang=js"
export * from "./Geophysical.vue?vue&type=script&lang=js"
import style0 from "./Geophysical.vue?vue&type=style&index=0&id=7210f73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7210f73c",
  null
  
)

export default component.exports